export const PAYMENT_ROLLBACK_ERROR =
  'There was an unexpected error loading the Payment Rollback Model. Please try again and contact support if the problem persists.';
export const PAYMENT_ROLLBACK_INVALID_NUMBER_ERROR =
  'The entered value is not a valid decimal number. Please try again with a valid decimal number.';
export const PAYMENT_ROLLBACK_DEFAULT_MESSAGE_IF_NO_OFFER_EXISTS =
  'Please enter New Rollback Payment and Fields To Adjust to see your new rollback offer.';

export const PAYMENT_ROLLBACK_DEBOUNCE_WAIT_IN_MS = 1000;
